import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useAuthSiteStore } from '../../user/authSiteStore'

export function useSiteContext() {
  const authSiteStore = useAuthSiteStore()
  const { currentSite, config, permissions } = storeToRefs(authSiteStore)

  if (!currentSite.value || !config.value || !permissions.value) {
    throw new Error('useSiteContext() called outside an org-scoped route.')
  }

  return {
    site: computed(() => currentSite.value!),
    config: computed(() => config.value!),
    permissions: computed(() => permissions.value),
  }
}
